import { render, staticRenderFns } from "./IVRsDetail.vue?vue&type=template&id=22f865a9"
import script from "./IVRsDetail.vue?vue&type=script&lang=ts"
export * from "./IVRsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports